import React, { Component,Fragment } from 'react';
import { Route} from 'react-router-dom';

import Layout from './components/Layout/Layout'; 
import Footer from './components/Layout/Footer'; 
import Department,{Departmentroutes} from './components/Department/index'; 
import Library,{Libraryroutes} from './components/Library/index'; 
import Setting,{Settingroutes} from './components/Setting/index'; 
import Student,{Studentroutes} from './components/Student/Index'; 
import Staff,{Staffroutes} from './components/Staff/index'; 
import Login from './components/Login/Login';
import Reports ,{ReportsRoutes}from './components/Reports/index';
import Landing from './Landing';
 
export const routes = [
    {
        path: '/department',
        name:'Department',
        component: Department,
        routes:Departmentroutes,
        show:true,
        icon:'domain'
    },
    {
        path: '/staffs',
        name:'Staff',
        component: Staff,
        routes:Staffroutes,
        show:true,
        icon:'wc'
    },
    {
        path: '/student',
        name:'Student',
        component: Student,
        routes:Studentroutes,
        show:true,
        icon:'group'
    },
    {
        path: '/library',
        component: Library,
        name:'Library',
        routes:Libraryroutes,
        show:true,
        icon:'local_library'
    },
    {
        path: '/setting',
        component: Setting,
        name:'Setting',
        routes:Settingroutes,
        show:true,
        icon:'settings'
    },
    {
        path: '/reports',
        component: Reports,
        name:'Reports',
        routes:ReportsRoutes,
        show:true,
        icon:'insert_drive_file'
    },
    {
        path: '/landing',
        component: Landing,
        name:'Landing',  
    },
    {
        path: '',
        component: Landing,
        name:'Landing',  
        exact:true
    }
];
class Main extends Component {
    componentDidMount(){
        window.omni_page_onload.init();
        window.omni_page_afterload.init();
        window.omni_main_header.init();
        window.omni_main_sidebar.init();
        window.omni_style_switcher.init(); 
        window.omni_md.init(); 
        window.omni_forms.init(); 
    }

    loginCheck(){
        return localStorage.getItem('token')?true:false;
    }

    render() { 
        const loginCheck=this.loginCheck(); 
        return ( 
            <Fragment> 
                { loginCheck?
                    <Fragment>
                        <Route path="/"  component={Layout} />
                        <div id={`${loginCheck?'page_content':' '}`}> 
                            {routes.map((route) => 
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.component}
                                />
                            )}
                             
                            <Footer/>
                        </div>
                    </Fragment>:
                    <Route path="/" component={Login} />
                }
                 
            </Fragment>
        );
    }
} 
export default Main;


// WEBPACK FOOTER //
// ./src/Routes.js